(() => {
  if (new URLSearchParams(window.location.search).get('eleat_cta_control') === '1') return;
  const initialise = root => {
    root.querySelectorAll('.product-template__plan').forEach(plan => {
      if (plan.dataset.eleatCtaInitialised) return;
      const button = plan.querySelector('.product-template__plan-cta');
      if (!button) return;
      plan.dataset.eleatCtaInitialised = 'true';
      const slot = document.createElement('div');
      slot.className = 'eleat-plan-cta-slot';
      slot.setAttribute('aria-hidden', 'true');
      let frame = 0;
      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(position);
      };
      function position() {
        frame = 0;
        if (!plan.isConnected || !plan.getClientRects().length) return;
        const card = plan.querySelector('.product-template__plan-option.active');
        const expanded = card?.querySelector('.plan-option__expanded');
        if (!expanded) {
          if (plan.classList.contains('eleat-cta-in-card')) plan.classList.remove('eleat-cta-in-card');
          slot.remove();
          return;
        }
        if (slot.parentElement !== expanded) expanded.appendChild(slot);
        const height = Math.ceil(button.getBoundingClientRect().height);
        if (height < 1) return;
        if (slot.style.height !== `${height}px`) slot.style.height = `${height}px`;
        const area = plan.getBoundingClientRect();
        const target = slot.getBoundingClientRect();
        if (target.width < 1) return;
        plan.style.setProperty('--eleat-cta-card-top', `${target.top - area.top - plan.clientTop + plan.scrollTop}px`);
        plan.style.setProperty('--eleat-cta-card-left', `${target.left - area.left - plan.clientLeft + plan.scrollLeft}px`);
        plan.style.setProperty('--eleat-cta-card-width', `${target.width}px`);
        if (!plan.classList.contains('eleat-cta-in-card')) plan.classList.add('eleat-cta-in-card');
      }
      const mutations = new MutationObserver(schedule);
      mutations.observe(plan, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-checked', 'aria-hidden', 'hidden'] });
      const resize = new ResizeObserver(schedule);
      resize.observe(plan);
      resize.observe(button);
      plan.querySelectorAll('.product-template__plan-option').forEach(card => resize.observe(card));
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('pageshow', schedule);
      document.fonts?.ready.then(schedule);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(plan)) return;
        mutations.disconnect();
        resize.disconnect();
        cancelAnimationFrame(frame);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('pageshow', schedule);
      });
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
